import type { ActionEvent, PageViewEvent, PartialScreenEvent } from '.'
import type { SDKEventAttrs } from '@mparticle/web-sdk'

export enum AnalyticsEventType {
  SCREEN = 'Screen',
  PARTIAL_SCREEN = 'Partial Screen Load',
  USER_ACTION = 'User Action',
}

export enum PartialScreenInterfaceType {
  MODAL = 'modal',
  POPUP = 'popup',
  INTERSTITIAL = 'interstitial',
}

export enum UserActionInterfaceType {
  BUTTON = 'button',
  LINK = 'link',
}

export const STRICTLY_NECESSARY_EVENTS: Array<
  Partial<ActionEvent | PageViewEvent | PartialScreenEvent>
> = [
  { actionName: 'acceptAllCookies' },
  { actionName: 'manageCookieConsents' },
  { actionName: 'exitManageCookieConsentDetails' },
  { actionName: 'applyCookieConsents' },
  { partialScreenName: 'manageCookieConsents' },
  { partialScreenName: 'manageCookieConsentDetails' },
  { pageTitle: 'App-Only Error' },
  { pageTitle: 'Error 404' },
  { pageTitle: 'Customer unsubscribe' },
]

const marketMappings: Record<string, Record<string, SDKEventAttrs[string]>> = {
  'gb/en': {
    market: 'UK',
    'segment.id': 'GBRC',
    'segment.entity': 'JPMEL',
    'segment.business_type': 'Retail',
    'segment.markets': 'UK',
  },
  'de/de': {
    market: 'Germany',
    'segment.id': 'DERC',
    'segment.entity': 'JPMSE',
    'segment.business_type': 'Retail',
    'segment.markets': 'Germany',
  },
}

export const getMarketMapping = ():
  | Record<string, SDKEventAttrs[string]>
  | undefined => {
  return marketMappings[process.env.AEM_LANGUAGE_PATH as string]
}
